import { Directive, ElementRef, Renderer2, OnInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[unhObserveResize]'
})
export class ObserveResizeDirective implements OnInit, OnDestroy {

  private destroyResizeListener: () => void;

  constructor(private elRef: ElementRef, private r2: Renderer2) { }
  ngOnInit() {
      this.destroyResizeListener = this.r2.listen('window', 'resize', evt => this.onScroll(evt));
  }
  onScroll(evt: Event) {
  }

  ngOnDestroy() {
    if (this.destroyResizeListener != null) {
      this.destroyResizeListener();
    }
  }
}
